import React from 'react';

import { flagStyles } from '../settings';

const SvgSI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4752px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSI;
